import styled from "styled-components";

export const ReqOptionsContStyled = styled.div`
  font-size: 0.8em;
  color: white;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .req-options_btn {
    color: inherit;
    width: 36px;
    height: 36px;
    margin: 0 0 12px 12px;
    border-radius: 12px;
  }

  .req-options_btn--blue {
    width: 78px;
    padding: 0 9px;
    height: 36px;
    box-shadow: 0 3px 10px 0 rgba(50, 120, 215, 0.4);
    background-color: #3278d7;
  }

  .req-options_btn--red {
    box-shadow: 0 3px 10px 0 rgba(237, 85, 101, 0.4);
    background-color: #ed5565;
  }

  .req-options_btn--dark {
    box-shadow: 0 3px 10px 0 rgba(42, 46, 67, 0.4);
    background-color: #2a2e43;
  }
`;
